var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPhoneFilled = function SvgPhoneFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.042 13.525-.392 2.692a1.039 1.039 0 0 1-1.025.891H15.6a12.905 12.905 0 0 1-5.117-1.208 12.964 12.964 0 0 1-3.725-2.608A13.179 13.179 0 0 1 4.15 9.567a12.866 12.866 0 0 1-1.208-5.109A1.045 1.045 0 0 1 3.833 3.4l2.7-.4a1.041 1.041 0 0 1 1.159.758l.966 3.609A1.052 1.052 0 0 1 8.05 8.6l-.6.25a9.782 9.782 0 0 0 3.725 3.825l.275-.667c.2-.483.725-.741 1.233-.608l3.609.967c.508.133.841.633.758 1.158h-.008Z",
    fill: "current"
  })));
};
export default SvgPhoneFilled;